import { createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'

const configSlice = createSlice({
  name: 'config',
  initialState: {
    runtimeConfig: null,
  },
  reducers: {
    setConfig: (state, action) => {
      state.runtimeConfig = action.payload
    },
  },
  extraReducers: (builder) =>
    builder.addCase(HYDRATE, (state, action) => {
      if (!state.runtimeConfig) {
        state.runtimeConfig = action.payload.config.runtimeConfig
      }
    }),
})

export const { setConfig } = configSlice.actions

export default configSlice.reducer
